export const getIsOldAppVersion = (state) => state.version;
